module.exports = __webpack_public_path__ + "img/FI23295892.774d9d4d.png";